import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';
import { BedCountLauncher } from '@/components/bedcount/BedCountLauncher';

interface ClientsBedCountModeProps {
  siteId: string | null;
  siteName?: string;
  canSignOff?: boolean;
}

export const ClientsBedCountMode: React.FC<ClientsBedCountModeProps> = ({
  siteId, siteName, canSignOff = false,
}) => {
  if (!siteId) {
    return (
      <Card>
        <CardContent className="p-8 text-center text-muted-foreground">
          <AlertCircle className="h-10 w-10 mx-auto mb-3 opacity-60" />
          <p className="font-medium">No facility selected</p>
          <p className="text-sm mt-1">Select a facility to view or start a bed count.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <BedCountLauncher
      siteId={siteId}
      siteName={siteName}
      canSignOff={canSignOff}
      variant="panel"
    />
  );
};
